import React from 'react'
import ReactDOM from 'react-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { StyledEngineProvider } from '@mui/material/styles'
import FirebaseProvider from './utils/firebase'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import App from './components/App/'
import ColorThemeProvider from './contexts/ColorThemeContext'
import { EnhancerProvider } from './contexts/EnhancerContext'

posthog.init(process.env.REACT_APP_VITE_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
})

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ColorThemeProvider>
      <PostHogProvider client={posthog}>
        <FirebaseProvider>
          <EnhancerProvider>
            <CssBaseline />
            <App />
          </EnhancerProvider>
        </FirebaseProvider>
      </PostHogProvider>
    </ColorThemeProvider>
  </StyledEngineProvider>,
  document.getElementById('root')
)